import React from "react";

import { Table, flexRender } from "@tanstack/react-table";
import { TableHeaderFilter } from "./Filters/TableHeaderFilter";

interface TableHeaderProps {
  table: Table<any>;
  setSelectedRows: React.Dispatch<React.SetStateAction<Set<any>>>;
  onSelectionChange?: (selectedRows: any[]) => void;
  numberOfSelectedRows: number;
  renderFilters?: boolean;
  // Phones: column `size`s are desktop widths and would force sideways scrolling
  ignoreColumnSizes?: boolean;
}
export const TableHeader = React.memo(
  ({
    table,
    setSelectedRows,
    numberOfSelectedRows,
    onSelectionChange,
    renderFilters,
    ignoreColumnSizes,
  }: TableHeaderProps) => {
    return (
      <thead>
        {table.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {onSelectionChange && (
              <th
                onClick={(e) => {
                  e.stopPropagation();
                  const newSelectedRows =
                    table.getRowModel().rows.length === numberOfSelectedRows
                      ? new Set()
                      : new Set(
                          table.getRowModel().rows.map((row) => row.original.id)
                        );
                  setSelectedRows(newSelectedRows);
                  if (onSelectionChange) {
                    onSelectionChange(Array.from(newSelectedRows));
                  }
                }}
                className="w-6 !m-0"
              >
                <input
                  type="checkbox"
                  checked={
                    table.getRowModel().rows.length === numberOfSelectedRows &&
                    numberOfSelectedRows > 0
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      const newSelectedRows = new Set(
                        table.getRowModel().rows.map((row) => row.original.id)
                      );
                      setSelectedRows(newSelectedRows);
                      if (onSelectionChange) {
                        onSelectionChange(Array.from(newSelectedRows));
                      }
                    } else {
                      setSelectedRows(new Set());
                      if (onSelectionChange) {
                        onSelectionChange([]);
                      }
                    }
                  }}
                />
              </th>
            )}
            {headerGroup.headers.map((header) => {
              return (
                <th
                  {...{
                    key: header.id,
                    colSpan: header.colSpan,
                    style: ignoreColumnSizes
                      ? undefined
                      : {
                          width: isNaN(header.getSize())
                            ? header.getSize()
                            : `${header.getSize()}px`,
                        },
                  }}
                  className={`px-2 py-3 whitespace-nowrap`}
                >
                  <div className="text-left flex items-start flex-col justify-start">
                    <label
                      className={`flex text-sm font-medium mb-1 truncate ${
                        header.column.getCanSort()
                          ? "cursor-pointer select-none"
                          : ""
                      }`}
                      onClick={header.column.getToggleSortingHandler()}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                      {/* {{
                        asc: <MdKeyboardArrowUp />,
                        desc: <MdKeyboardArrowDown />,
                      }[header.column.getIsSorted() as string] ?? null} */}
                    </label>
                    {renderFilters &&
                      (header.column.getCanFilter() ? (
                        <TableHeaderFilter column={header.column} />
                      ) : (
                        <div className="h-[1.9rem]"></div>
                      ))}
                  </div>
                </th>
              );
            })}
          </tr>
        ))}
      </thead>
    );
  },
  (prevProps, nextProps) => {
    const prevColumns = prevProps.table
      .getHeaderGroups()
      .flatMap((group) => group.headers.map((header) => header.id));
    const nextColumns = nextProps.table
      .getHeaderGroups()
      .flatMap((group) => group.headers.map((header) => header.id));

    return (
      prevProps.table === nextProps.table &&
      prevProps.numberOfSelectedRows === nextProps.numberOfSelectedRows &&
      JSON.stringify(prevColumns) === JSON.stringify(nextColumns)
    );
  }
);
